import { convertToISO8601, formatDateUTCToDisplay } from '@helpers/date'
import { Spacer, Text } from '@ui-kit'
import { useTranslation } from 'react-i18next'
import { Column, Row } from 'simple-flexbox'

import styles from './Fields.module.scss'

export const CreateDateField = ({ date }: { date: string }) => {
  const { t } = useTranslation()

  return (
    <Column>
      <Text size={14} color='neutral-6'>
        {t('modal.leads.details.created.at')}
      </Text>

      <Row alignItems='center' className={styles.field}>
        <Text size={16} color='neutral'>
          {formatDateUTCToDisplay(convertToISO8601(date))}
        </Text>
      </Row>

      <Spacer space={10} />
    </Column>
  )
}
